import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import cookie from 'js-cookie'
import { userTokenKey } from '@/config/index'
Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history'
})

// 监听router push报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(err => err)
}

const noLoginPages = [ // 允许非登录状态下访问的页面
  '/download',
  '/privacy',
  '/agreement'
]

router.beforeEach((to, from, next) => {
  const token = cookie.get(userTokenKey)
  
  if (noLoginPages.includes(to.path)) {
    next()
  } else if (!token && to.path !== '/login') { // 未登录状态下只能访问登录页
    next('/login')
  } else if (token && to.path === '/login') {
    next('/index')
  } else {
    next()
  }
})

export default router